import { localStorageKeys } from '@/app/config/localStorageKeys'
import { useState } from 'react'

export default function useLocalStep() {
  const localDontShowAgain = Boolean(
    localStorage.getItem(localStorageKeys.DONT_SHOW_LIVE_MESSAGE_AGAIN),
  )

  const [step, setStep] = useState(localDontShowAgain ? 1 : 0)

  const markDontShowMessageAgain = () => {
    localStorage.setItem(localStorageKeys.DONT_SHOW_LIVE_MESSAGE_AGAIN, 'true')
    setStep(1)
  }

  return {
    markDontShowMessageAgain,
    step,
    setStep,
    localDontShowAgain,
  }
}
